@if (variant === 'cards') {
    <div class="grid gap-2.5" [style.grid-template-columns]="'repeat(' + columns + ', minmax(0, 1fr))'">
        @for (option of options; track option.value) {
            <button type="button" (click)="select(option)"
                class="flex flex-col items-center justify-center gap-1.5 rounded-2xl border-[1.5px] px-2 py-3 text-xs font-semibold leading-tight text-center transition"
                [ngClass]="value === option.value ? 'border-[#317756] bg-[#DAF2E0] text-[#185545]' : 'border-[#DFE2E1] bg-white text-[#545F5A]'">
                @if (option.icon) {
                    <span class="text-2xl leading-none">{{ option.icon }}</span>
                }
                {{ option.label | translate }}
            </button>
        }
    </div>
} @else {
    <div class="flex flex-wrap gap-2">
        @for (option of options; track option.value) {
            <button type="button" (click)="select(option)"
                class="rounded-full border px-3.5 py-2 text-[13px] font-medium transition"
                [ngClass]="value === option.value ? 'border-[#317756] bg-[#317756] text-white' : 'border-[#DFE2E1] bg-white text-[#545F5A]'">
                @if (option.icon) {
                    <span class="mr-1">{{ option.icon }}</span>
                }
                {{ option.label | translate }}
            </button>
        }
    </div>
}
